import React, { useState } from "react";
import AlertMessage from "../../../partials/alertMessage";
import FileUpload from "../../../util/FileUpload";

const UpdateNoteCategory = ({ onSubmit, currentValue, onCancel }) => {
	const [message, setMessage] = useState(null);
	const [image, setImage] = useState(currentValue.icon);
	const nameRef = React.createRef();
	// Update current value
	setTimeout(() => {
		if (nameRef && nameRef.current)
			nameRef.current.value = currentValue.name;
	}, 0);
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const { value } = nameRef.current;
				if (value) {
					onSubmit({ name: value, icon: image });
					setMessage(null);
					nameRef.current.value = "";
				} else {
					setMessage("Note Activity's name is required!");
				}
			}}
		>
			<AlertMessage message={message} failed={true} />
			<div className="form-group">
				<input
					type="text"
					id="update-note-category"
					name="update-note-category"
					ref={nameRef}
					className="form-control input-height"
					placeholder="Note category name .."
				/>
			</div>
			<div className="form-group">
				<FileUpload
					title="Select Icon Image"
					onData={item => setImage(item.path)}
				/>
			</div>
			<div className="text-center m-b-20">
				<button
					type="button"
					onClick={() => onCancel()}
					className="mdl-button mdl-js-ripple-effect m-l-10 m-t-5 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success"
				>
					Update <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};
export default UpdateNoteCategory;
